<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    bottom
    left
    max-width="90%"
    min-width="200"
    offset-x
    offset-y
    origin="top right"
    transition="scale-transition"
  >
    <template v-slot:activator="{ attrs, on }">
      <v-card
        id="settings"
        class="py-2 px-4"
        color="#0000004D"
        dark
        flat
        style="position: fixed; top: 164px; right: -35px"
        width="100"
        v-bind="attrs"
        v-on="on"
      >
        <v-icon large>
          mdi-nfc-tap
        </v-icon>
      </v-card>
    </template>

    <v-card class="py-2">
      <base-title align="center" title="" space="" />

      <v-card-text>
        <v-item-group>
          <v-item>
            <v-btn
              color="blue lighten-1"
              href="https://x.com/maritechone"
              target="_blank"
              icon
              x-large
            >
              <v-icon>
                mdi-twitter
              </v-icon>
            </v-btn>
          </v-item>

          <v-item>
            <v-btn
              color="blue"
              href="https://www.facebook.com"
              target="_blank"
              icon
              x-large
            >
              <v-icon>
                mdi-facebook
              </v-icon>
            </v-btn>
          </v-item>

          <v-item>
            <v-btn
              color="blue lighten-2"
              href="https://www.linkedin.com/company/maritech-software"
              target="_blank"
              icon
              x-large
            >
              <v-icon>
                mdi-linkedin
              </v-icon>
            </v-btn>
          </v-item>

          <v-item>
            <v-btn
              color="green darken-2"
              href="https://api.whatsapp.com/send?phone=6590461599&text=I'm interested in your Maritime Software Services"
              target="_blank"
              icon
              x-large
            >
              <v-icon>
                mdi-whatsapp
              </v-icon>
            </v-btn>
          </v-item>
        </v-item-group>
      </v-card-text>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  name: "HomeSettings",

  data() {
    return {
      colors: [this.$vuetify.theme.themes.light.primary, "#9368e9", "#F4511E"],
      menu: false
    };
  }
};
</script>
